import React, { useState, useCallback, useEffect } from 'react'


//* Components
import { Image } from 'components/common'
import { Form, Upload } from 'antd'
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'

const SingleUpload = ({ form, name, defaultUrl, isLocal, errorKey }) => {
    const [loading, setLoading] = useState(false)
    const [image, setImage] = useState()


    const getBase64 = (img, callback) => {
        const reader = new FileReader()
        reader.addEventListener('load', () => callback(reader.result))
        reader.readAsDataURL(img)
    }

    //! On Upload Change
    const onChange = useCallback(({ file: fileObj }) => {
        getBase64(fileObj, imageUrl => {
            setImage(imageUrl)
            setLoading(false)
            form.current.setFieldsValue({ [name]: fileObj })
        })
    }, [form])

    //! Uploader Fake Request
    const fakeRequest = useCallback(({ onSuccess }) => {
        onSuccess('ok')
    }, [])

    //! Default Value Set
    useEffect(() => {
        if (defaultUrl) {
            if (isLocal) {
                getBase64(defaultUrl, imageUrl => {
                    setImage(imageUrl)
                })
            } else {
                setImage(defaultUrl)
            }
        }
    }, [isLocal, defaultUrl])

    return (
        <Form.Item
            name={name}
            rules={[{ required: true }]}
            messageVariables={{ errorKey: errorKey }}>
            <Upload
                accept='image/png,  image/jpeg, image/jpg'
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                customRequest={fakeRequest}
                beforeUpload={() => false}
                onChange={onChange}
            >
                {image && <Image className='reload' src='/images/reload.svg' />}
                {image ? <img src={image} alt="avatar" style={{ width: '100%' }} /> : (
                    <div>
                        {loading ? <LoadingOutlined /> : <PlusOutlined />}
                        <div style={{ marginTop: 8 }}>Upload</div>
                    </div>
                )}
            </Upload>
        </Form.Item>
    )
}
export default SingleUpload
